var menuButton = document.querySelector("#hamburgerMenu");
const anchorLinks = document.querySelectorAll("a[href*='#']");
if (menuButton) {
    menuButton.addEventListener("click", function (e) {
        if (e.target.classList.contains("active")) {
            document.body.classList.remove("menu_active");
            e.target.classList.remove("active");
            e.target.setAttribute("aria-expanded", "false");
            e.target.setAttribute("aria-label", "Close navigation menu");
        } else {
            document.body.classList.add("menu_active");
            e.target.classList.add("active");
            e.target.setAttribute("aria-expanded", "true");
            e.target.setAttribute("aria-label", "Open navigation menu");
        }
    })
}

if (anchorLinks) {
    anchorLinks.forEach(element => {
        element.addEventListener("click", function (e) {
            var link = e.target.href;
            var linkSplut = link.split('#');
            if (linkSplut.length > 1) {
                var linkAnch = linkSplut[1];
                const linkObj = document.querySelector("#scrollto_" + linkAnch);
                if (linkObj) {
                    e.preventDefault();
                    window.scrollTo({
                        top: getOffsetTop(linkObj),
                        behavior: 'smooth'
                    });
                }
            }
        })
    });
}

let locHash = window.location.hash;
if (locHash != undefined && locHash != null && locHash != "") {
    var linkInterval = setInterval(() => {
        if (document.readyState == 'complete') {
            clearInterval(linkInterval);
            if (locHash) {
                locHash = locHash.replace('#', '#scrollto_');
                const linkObj2 = document.querySelector(locHash);
                if (linkObj2) {
                    window.scrollTo({
                        top: getOffsetTop(linkObj2),
                        behavior: 'smooth'
                    });
                }
            }
        }
    }, 500);
}

function getOffsetTop(element) {
    return element ? (element.offsetTop + getOffsetTop(element.offsetParent)) - 50 : 0;
}